import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const LojaIluminacao = () => {
  const wpp = generateWhatsAppLink('loja', 'loja-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Lojas de Iluminação | Sustenta LED</title>
        <meta name="description" content="Atacadista e distribuidora de LED para lojas de iluminação. Mix completo, marcas homologadas e suporte para ampliar suas vendas." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Lojas de Iluminação</h1>
              <p>Somos atacadistas e distribuidores com portfólio para lojas especializadas em iluminação. Oferecemos linhas decorativas e técnicas, com suporte para mix, exposição e especificação.</p>
              <p>Trabalhamos com plafons, pendentes, spots, trilhos e fitas LED, garantindo qualidade, disponibilidade e logística eficiente. Ideal para varejo e projetos.</p>
              <p>Receba condições exclusivas para lojistas e suporte consultivo para ampliar suas vendas com LED.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/clientes/banner_loja.jpg" alt="Luminárias de LED para Lojas de Iluminação - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default LojaIluminacao;
